import { apiGet } from '@/api/http';

import type { Certificate } from '@/types/reference';

const api_url = import.meta.env.VITE_API_URL;

export const getCertificatesList = () =>
  apiGet<Certificate[]>(`${api_url}certificates/`);
